<template>
  <div
    v-if="selections.length"
    class="selected-choice-summary px-6 pb-4 md:px-16 xl:px-32"
  >
    <div class="selected-choice-summary__content mx-auto w-full max-w-5xl md:grid md:grid-cols-2 md:items-center md:gap-10 text-left">
      <img
        v-if="topImage"
        :alt="topImage.alt"
        :src="topImage.source"
        class="selected-choice-summary__image mb-6 md:mb-0 flex-shrink-0 rounded-2xl object-cover"
      />

      <div class="selected-choice-summary__details min-w-0 flex flex-col gap-6">
        <div
          v-for="(selection, index) in selections"
          :key="index"
          class="selected-choice-summary__item"
        >
          <h4 class="text-lg font-bold uppercase tracking-0.5px text-primary mb-1">
            {{ choiceTitle(selection) }}
          </h4>
          <div
            v-if="!isEmptyHtml(selection.answer.description)"
            class="selected-choice-summary__description text-base font-bold text-black-darkest"
            v-dompurify-html="selection.answer.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { Selection } from '@/model'
import { isEmptyHtml } from '@/utils/html'

export default defineComponent({
  name: 'SelectedChoiceSummary',
  props: {
    selections: {
      type: Array as () => Selection[],
      default: () => []
    },
    editSelectionsText: {
      type: String,
      default: ''
    }
  },
  emits: ['editSelections'],
  setup (props) {
    const topImage = computed(() => props.selections[0]?.answer.image)

    const choiceTitle = (selection: Selection) =>
      selection.answer.headingSummary || selection.toString()

    return {
      topImage,
      choiceTitle,
      isEmptyHtml
    }
  }
})
</script>

<style scoped>
.selected-choice-summary {
  &__image {
    width: 100%;
    height: auto;
    max-height: 320px;
    object-position: center;
    border-radius: 1rem;
    overflow: hidden;
  }
}

@screen md {
  .selected-choice-summary {
    &__image {
      width: 100%;
      max-width: 480px;
      height: auto;
      max-height: 384px;
    }
  }
}
</style>
